<template>
  <section id="expired-link-reset">
    <img
      class="nothing-going-on"
      src="@shared/assets/img/general/svg/not-found.svg"
    >
  </section>
</template>

<script>
export default {
  name: 'ExpiredLinkResetView',
  metaInfo: {
    title: 'SmartAC.com | Expired Link Reset',
  },
};
</script>

<style lang="scss">
section#expired-link-reset {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;

  .nothing-going-on {
    height: 90vh;
  }
}
</style>
